import { List, Map, fromJS } from 'immutable';

import * as constAction from 'root/actionConstants';
import { listFindByMapId } from 'core/generalFunctions';

const defaultState = Map({
  lista: List(),
  vehiculo: Map(),
  eliminarId: false,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.VEHICULOS_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.VEHICULOS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.VEHICULOS_SET_CHOFER: {
      return state.setIn(['vehiculo', '_chofer'], action.payload);
    }
    case constAction.VEHICULOS_SET_DISPOSITIVO: {
      return state.setIn(['vehiculo', '_dispositivo'], action.payload);
    }
    case constAction.VEHICULOS_DELETE: {
      let index = listFindByMapId(state.get('lista'), action.state.id, true);
      return state.deleteIn(['lista', index]);
    }
    case constAction.VEHICULOS_LISTA_SET: {
      let newState = state.get('lista'),
        index = listFindByMapId(newState, action.payload.id, true);
      newState = index === -1 ? newState.push(Map(action.payload)) : newState.set(index, Map(action.payload));
      return state.set('lista', newState);
    }
  }
  return state;
}



// WEBPACK FOOTER //
// src/modules/vehiculos/reducer.js